import { batch } from 'react-redux';

// project imports
import gestopAPI from 'utils/gestopAPI';
import { dispatch } from 'store/index';
import { errorProcessor } from 'utils/processors';
import { tplWorkOrderActions } from './slice';
import capabilities from './capabilities';

export const ApiTplWorkOrdersGetCollection = async ({
    filters = [],
    orderBy = [],
    groupBy = [],
    page = 1,
    limit = 10,
    includeSafeDeleted = false,
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(tplWorkOrderActions.startLoading());
    }

    await gestopAPI
        .post('tplmgmt/workorders/list', { filters, orderBy, groupBy, page, limit, includeSafeDeleted }, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(tplWorkOrderActions.setList(response?.data?.list));
                    dispatch(tplWorkOrderActions.setCount(response?.data?.count));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(tplWorkOrderActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data?.list);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(tplWorkOrderActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(tplWorkOrderActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiTplWorkOrdersCountCollection = async ({
    filters = [],
    includeSafeDeleted = false,
    successCallback = () => {},
    errorCallback = () => {},
    config = {}
}) => {
    await gestopAPI
        .post('tplmgmt/workorders/count', { filters, includeSafeDeleted }, config)
        .then((response) => {
            if (typeof successCallback === 'function') {
                successCallback(response?.data?.count);
            }
        })
        .catch((error) => {
            const errorMsg = errorProcessor(error?.response?.data);

            if (typeof errorCallback === 'function') {
                errorCallback(errorMsg);
            }
        });
};

export const ApiTplWorkOrdersPostCollection = async ({
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(tplWorkOrderActions.startLoading());
    }

    await gestopAPI
        .post('tplmgmt/workorders', data, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(tplWorkOrderActions.insertItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(tplWorkOrderActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(tplWorkOrderActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(tplWorkOrderActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiTplWorkOrdersDeleteCollection = async ({
    ids = [],
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(tplWorkOrderActions.startLoading());
    }

    await gestopAPI
        .post('tplmgmt/workorders/delete', ids, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(tplWorkOrderActions.deleteItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(tplWorkOrderActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(tplWorkOrderActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(tplWorkOrderActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiTplWorkOrdersExportCollection = async ({
    exportType = 'allRows',
    format = 'pdf',
    columns = [],
    filters = [],
    orderBy = [],
    groupBy = [],
    successCallback = () => {},
    errorCallback = () => {},
    config = {}
}) => {
    if (capabilities.app.includes('exporter')) {
        dispatch(tplWorkOrderActions.startExporting());
    }

    await gestopAPI
        .post('tplmgmt/workorders/export', { exportType, format, columns, filters, orderBy, groupBy }, { ...config, responseType: 'blob' })
        .then((response) =>
            batch(() => {
                window.open(URL.createObjectURL(response?.data));

                if (capabilities.app.includes('exporter')) {
                    dispatch(tplWorkOrderActions.stopExporting());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('exporter')) {
                    dispatch(tplWorkOrderActions.stopExporting());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(tplWorkOrderActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiTplWorkOrdersPutItem = async ({
    id,
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(tplWorkOrderActions.startLoading());
    }

    await gestopAPI
        .put(`tplmgmt/workorders/${id}`, data, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(tplWorkOrderActions.updateItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(tplWorkOrderActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(tplWorkOrderActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(tplWorkOrderActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiTplWorkOrdersPatchItem = async ({
    id,
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(tplWorkOrderActions.startLoading());
    }

    await gestopAPI
        .patch(`tplmgmt/workorders/${id}`, data, {
            ...config,
            headers: { ...config?.headers, 'Content-Type': 'application/merge-patch+json' } // Specific content type for PATCH requests
        })
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(tplWorkOrderActions.updateItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(tplWorkOrderActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(tplWorkOrderActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(tplWorkOrderActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiTplWorkOrdersDeleteItem = async ({
    id,
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(tplWorkOrderActions.startLoading());
    }

    await gestopAPI
        .delete(`tplmgmt/workorders/${id}`, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(tplWorkOrderActions.deleteItems(id));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(tplWorkOrderActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(tplWorkOrderActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(tplWorkOrderActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiTplWorkOrdersExportItem = async ({ id, successCallback = () => {}, errorCallback = () => {}, config = {} }) => {
    if (capabilities.app.includes('exporter')) {
        dispatch(tplWorkOrderActions.startExporting());
    }

    await gestopAPI
        .get(`tplmgmt/workorders/export/${id}`, { ...config, responseType: 'blob' })
        .then((response) =>
            batch(() => {
                window.open(URL.createObjectURL(response?.data));

                if (capabilities.app.includes('exporter')) {
                    dispatch(tplWorkOrderActions.stopExporting());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('exporter')) {
                    dispatch(tplWorkOrderActions.stopExporting());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(tplWorkOrderActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiTplWorkOrdersGetItem = async ({ id, successCallback = () => {}, errorCallback = () => {}, config = {} }) => {
    if (capabilities.app.includes('loader')) {
        dispatch(tplWorkOrderActions.startLoading());
    }

    await gestopAPI
        .get(`tplmgmt/workorders/${id}`, config)
        .then((response) =>
            batch(() => {
                if (capabilities.app.includes('loader')) {
                    dispatch(tplWorkOrderActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(tplWorkOrderActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(tplWorkOrderActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};
